export default async function uriLoadHandler(uri: string, fileName: string) {
  const res = await fetch(uri);
  const url = window.URL.createObjectURL(await res.blob());
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', fileName);
  document.body.appendChild(link);
  link.click();
  window.URL.revokeObjectURL(url);
  link.remove();
}
